import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';
import Link from '@mlb/react-patterns/v4/components/Link/link';

const {
    mlbBlack
} = COLORS;

export const GameInfoLayerWrapper = styled.div`
    padding-left: ${({ theme }) => theme.GameInfoLayerWrapper.paddingLeft};
    padding-right: ${({ theme }) => theme.GameInfoLayerWrapper.paddingRight};
    margin-top: ${({ theme }) => theme.GameInfoLayerWrapper.marginTop};
    line-height: 10px;
`;

export const PromotionLabelWrapper = styled.div.attrs({
    'data-mlb-test': 'promotionLabel'
})`
    border-radius: 2px;
    padding: 1px 2px 0px 2px;
    font-weight: 700;
    font-size: ${({ theme }) => theme.GameInfoLayerWrapper?.PromotionLabelWrapper?.fontSize};
    height: ${({ theme }) => theme.GameInfoLayerWrapper?.PromotionLabelWrapper?.height};
    line-height: ${({ theme }) => theme.GameInfoLayerWrapper?.PromotionLabelWrapper?.lineHeight};
    color: ${mlbBlack};
    text-transform: capitalize;
    transform: translateY(-1px);
    box-sizing: content-box;
`;

export const NationalBroadcastWrapper = styled(PromotionLabelWrapper)`
    padding-top: 0px;
`;

export const LinkOverride = styled(Link)`
    color: ${mlbBlack};
    height: 11px;
    &:hover {
        color: ${mlbBlack};
    }
`;

export const WatchFreeWrapper = styled(PromotionLabelWrapper)`
    background-color: #FFB833;
    text-transform: capitalize;
`;
